import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { isStudentAuthenticated } from "../session"
import { learnPaths } from "../constants"

/**
 * Gate for every lecture route that needs a signed-in student. Redirects to
 * the portal's own login page -- never to the staff login.
 */
export default function RequireStudent({ children }) {
    const location = useLocation()

    if (!isStudentAuthenticated()) {
        return (
            <Navigate
                to={learnPaths.login}
                replace
                state={{ from: location.pathname }}
            />
        )
    }

    return children
}
